export default __webpack_public_path__ + "locales/el-GR/FilesSettings.json?hash=04f66c58d1abbdbb7079ec89299c7a9c";